import {RetailerApplicationAssessment} from '@core/model/retailer/application-form.model';
import {displayShortDate} from '@ui-kit/framework/util/static/date-format-utils';
import {
  Date,
  DefaultSearchTerms,
  DisplayFunction,
  DisplayOrder,
  ExportFunction,
  Number,
  SortDefault,
  String,
  TableDisplayedDefault
} from '@ui-kit/webkit/components/crud-item/crud-item-decorator';
import {ApplicationAssessmentStatus, Retailer, TenantType} from '../retailers.model';

type CrudRetailerContactModel = Pick<Retailer,
  "id" |
  "companyName" |
  "createDate" |
  "websiteUrl" |
  "curationAssessment" |
  "socialLink" |
  "ownerFirstname" |
  "ownerLastname" |
  "ownerEmail" |
  "tenantType" |
  "curated" |
  "phoneNumber"
>;

@DefaultSearchTerms(['tenant type:tenant'])
export class CrudRetailerContacts implements CrudRetailerContactModel {

  @DisplayOrder(1)
  @TableDisplayedDefault
  @Number("ID")
  id?: number;

  @DisplayOrder(2)
  @TableDisplayedDefault
  @String("Company Name")
  @SortDefault("asc")
  companyName: string;

  @DisplayOrder(3)
  @TableDisplayedDefault
  @String("Retailer")
  retailerName?: string;

  @DisplayOrder(4)
  @TableDisplayedDefault
  @String("Website")
  // @ClickFunction(openLinkInNewTab)
  websiteUrl: string;

  @DisplayOrder(5)
  @TableDisplayedDefault
  @String("Social Link")
  // @ClickFunction(openLinkInNewTab)
  socialLink: string | null;

  @DisplayOrder(6)
  @TableDisplayedDefault
  @String("Email")
  ownerEmail: string;

  @DisplayOrder(7)
  @TableDisplayedDefault
  @String("Phone Number")
  phoneNumber: string | null;

  @DisplayOrder(8)
  @TableDisplayedDefault
  @String("Tenant Type")
  tenantType: TenantType;


  @DisplayOrder(9)
  @DisplayFunction(displayShortDate)
  @ExportFunction(displayShortDate)
  @TableDisplayedDefault
  @Date("Application Date", "YYYY-MM-DD")
  createDate?: string | Date | undefined;

  @DisplayOrder(10)
  @TableDisplayedDefault
  @Number("Overall Score")
  overallScore!: number | null;

  @DisplayOrder(11)
  @TableDisplayedDefault
  @String("Curation Status")
  curated: ApplicationAssessmentStatus;

  curationAssessment?: RetailerApplicationAssessment | undefined;
  ownerFirstname: string;
  ownerLastname: string;

  constructor(obj: any = {}) {
    obj = obj || {};
    this.id = obj.id;
    this.companyName = obj.companyName;
    this.createDate = obj.createDate;
    this.websiteUrl = obj.websiteUrl;
    this.curationAssessment = obj.curationAssessment;
    this.socialLink = obj.socialLink;
    this.ownerFirstname = obj.ownerFirstname;
    this.ownerLastname = obj.ownerLastname;
    this.retailerName = this.ownerFirstname + " " + this.ownerLastname;
    this.ownerEmail = obj.ownerEmail;
    this.tenantType = obj.tenantType;
    this.curated = obj.curated;
    this.phoneNumber = obj.phoneNumber;
    this.overallScore = obj.overallScore;
  }
}
